export default {
    senderEmailData: state => state.senderEmailData
}
